var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEngageClients = function SvgEngageClients(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 14H1a1 1 0 0 1-1-1 6.002 6.002 0 0 1 3.873-5.612 4 4 0 1 1 4.958-6.214 4 4 0 0 1 3.297 7.214A6.003 6.003 0 0 1 16 14v1a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-1ZM6 1a3 3 0 0 0-1 5.829V8.1A5.003 5.003 0 0 0 1 13h3.083a6.009 6.009 0 0 1 3.79-4.612A3.997 3.997 0 0 1 6 5c0-1.414.734-2.657 1.842-3.368A2.985 2.985 0 0 0 6 1Zm3 6.829V9.1A5.003 5.003 0 0 0 5 14v1h10v-1a5.003 5.003 0 0 0-4-4.9V7.829a3 3 0 1 0-2 0Z",
    fill: "#000624"
  })));
};
export default SvgEngageClients;